export default {
  ASSETS_URL: "https://sindhi-website-assets.s3.ap-south-1.amazonaws.com/",
  ASSET_BUCKET_NAME: "sindhi-website-assets",
  API_URL: "https://app.sindhidryfruits.live/",
  S3_ACL: "public-read",
};
